import emptyApiResponse from 'assets/images/WarningLogo.png';
import { Button } from 'components/Button/Button';
import type { JSX } from 'react';
import { getSpacing } from 'stylesheet';

import {
  EmptyApiResponseContainer,
  EmptyApiResponseDescription,
  EmptyApiResponseImage,
  EmptyApiResponseTitle,
} from './EmptyApiResponse.style';

export interface EmptyStatusImageProps {
  width: string;
  height: string;
  src: string;
}

type Props = {
  title?: string;
  description?: string;
  buttonLabel?: string;
  onButtonClick?: () => void;
  emptyStatusImageProps?: EmptyStatusImageProps;
};

const defaultEmptyStatusImageProps = {
  src: emptyApiResponse,
  width: '155px',
  height: '116px',
};

export const EmptyApiResponse = ({
  title,
  description,
  buttonLabel,
  onButtonClick,
  emptyStatusImageProps,
}: Props): JSX.Element => {
  return (
    <EmptyApiResponseContainer>
      <EmptyApiResponseImage {...(emptyStatusImageProps ?? defaultEmptyStatusImageProps)} />
      {title && <EmptyApiResponseTitle>{title}</EmptyApiResponseTitle>}
      {description && <EmptyApiResponseDescription>{description}</EmptyApiResponseDescription>}
      {buttonLabel && (
        <Button
          displayStyle="filledOrange"
          onClick={onButtonClick}
          bigPaddings
          margins={`${getSpacing(3)} 0 0 0`}
        >
          {buttonLabel}
        </Button>
      )}
    </EmptyApiResponseContainer>
  );
};
